import React, { Component } from 'react'
import './HomeShowcase.css';
import PoweredBy from '../poweredby/PoweredBy';
import background from './../../img/homepage/showcase_header_2026.jpg';
<style>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap');
</style>


export class HomeShowcase extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: true,
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        }
        
        // Add resize handler for responsive adjustments
        this.handleResize = this.handleResize.bind(this);
    }
    
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize() {
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        });
        
        // Adjust positioning for very small screens to prevent overlap
        const titleContainer = document.querySelector('.title-container');
        const poweredBy = document.querySelector('.powered-by-container');
        
        if (titleContainer && poweredBy && window.innerHeight < 500) {
            // Ensure adequate spacing between elements on very small screens
            const titleBottom = titleContainer.getBoundingClientRect().bottom;
            const viewportHeight = window.innerHeight;
            
            // If title is too close to the bottom, adjust powered-by positioning
            if (viewportHeight - titleBottom < 100) {
                poweredBy.style.position = 'relative';
                poweredBy.style.marginTop = '20px';
            } else {
                poweredBy.style.position = '';
                poweredBy.style.marginTop = '';
            }
        }
    }
    
    render() {
        const showcaseStyle = {
            backgroundImage: `url(${background})`,
            height: `${this.state.windowHeight}px` // Dynamically set height based on window
        };
        
        return (
            <div className="landing-ether" style={showcaseStyle}>
                <div id="landing-page-container">
                    <div className="title-container">
                        <h1 className="main-title">
                            <span className="title-solid title-mac">MAC</span>
                            <span className="title-solid">FORMULA ELECTRIC</span>
                        </h1>
                        <h2 className="subtitle">
                            Learning. Teamwork. Excellence.
                        </h2>

                    </div>

                    <PoweredBy />
                </div>
            </div>
        );
    }
}

export default HomeShowcase
